<script lang="ts" setup>
const props = withDefaults(defineProps<{
    tag?: string;
    show?: boolean;
    fill?: boolean;
    column?: boolean;
    stretch?: boolean;
    start?: boolean;
    end?: boolean;
}>(), {
    tag: 'div',
    show: true,
    fill: true,
    column: true,
    stretch: true,
    start: true,
    end: true
});

const css = computed(() => ({
    'd-flex': props.show,
    'd-none': !props.show,
    'flex-fill': props.fill,
    'flex-column': props.show && props.column,
    'align-items-start': !props.stretch
}));
</script>

<template>
    <component :is="tag" :class="css">
        <template v-if="$slots.start || $slots.end">
            <IdeoPanel v-if="$slots.start" :column="column" :stretch="stretch" :fill="false" :class="{ 'me-3': start && !column, 'mb-2': start && column }">
                <slot name="start" />
            </IdeoPanel>
            <IdeoPanel :column="column" :stretch="stretch">
                <slot name="default" />
            </IdeoPanel>
            <IdeoPanel v-if="$slots.end" :column="column" :stretch="stretch" :fill="false" :class="{ 'ms-3': end && !column, 'mt-2': end && column }">
                <slot name="end" />
            </IdeoPanel>
        </template>
        <template v-else>
            <slot name="default" />
        </template>
    </component>
</template>
